// extracted by mini-css-extract-plugin
export default {"quickNav":"QuickNav_quickNav__kLEsa","quickPrompt":"QuickNav_quickPrompt__04yfi","quickChip":"QuickNav_quickChip__Hx2K+"};